import { render } from "./WebcamPromptCard.vue?vue&type=template&id=07a96404"
import script from "./WebcamPromptCard.vue?vue&type=script&lang=js"
export * from "./WebcamPromptCard.vue?vue&type=script&lang=js"

import "./WebcamPromptCard.vue?vue&type=style&index=0&id=07a96404&lang=scss"
script.render = render

export default script